export default __webpack_public_path__ + "static/media/happin-logo-06.c8008eb6.svg";